// COLLECTION FILTER JS
document.addEventListener('DOMContentLoaded', function () {

  const productContainer = document.querySelector('.ProductGridContainer');
  const facetForm = document.querySelector('.FacetFiltersForm');

  if (!productContainer || !facetForm) return;

  /* ------------------------------
     SERIALIZE FORM DATA
  --------------------------------*/
  function serializeForm(form) {
    const params = new URLSearchParams();

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
      params.append(input.name, input.value);
    });

    const minInput = form.querySelector('.price-min');
    const maxInput = form.querySelector('.price-max');

    if (minInput && minInput.value) {
      params.set('filter.v.price.gte', minInput.value);
    }

    if (maxInput && maxInput.value) {
      params.set('filter.v.price.lte', maxInput.value);
    }

    return params.toString();
  }

  /* ------------------------------
     CLEAR ALL BUTTON VISIBILITY
  --------------------------------*/
  function updateClearAllVisibility() {
    const hasChecked = facetForm.querySelectorAll('input[type="checkbox"]:checked').length > 0;
    const minVal = facetForm.querySelector('.price-min')?.value;
    const maxVal = facetForm.querySelector('.price-max')?.value;
    const hasPrice = !!(minVal || maxVal);
    const isActive = hasChecked || hasPrice;

    document.querySelectorAll('.facet-clear-all').forEach(btn => {
      btn.style.display = isActive ? '' : 'none';
    });
  }

  /* ------------------------------
     UPDATE PRODUCTS VIA AJAX
  --------------------------------*/
async function updateProducts(url) {
  try {
    productContainer.classList.add('is-loading');

    const response = await fetch(url);
    if (!response.ok) throw new Error('Network error');

    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');

    const newProducts = doc.querySelector('.ProductGridContainer');
    if (newProducts) {
      productContainer.innerHTML = newProducts.innerHTML;
    }
    const paginationParent = productContainer.parentElement;

    paginationParent.querySelector('.load-more-wrapper')?.remove();
    paginationParent.querySelector('.infinite-scroll-trigger')?.remove();
    paginationParent.querySelector('.infinite-loading-indicator')?.remove();
    paginationParent.querySelector('.pagination')?.remove();
    paginationParent.querySelector('.no-more-products-msg')?.remove();

    const newLoadMore = doc.querySelector('.load-more-wrapper');
    if (newLoadMore) paginationParent.appendChild(newLoadMore);

    const newTrigger = doc.querySelector('.infinite-scroll-trigger');
    if (newTrigger) paginationParent.appendChild(newTrigger);

    const newPagination = doc.querySelector('.pagination');
    if (newPagination) paginationParent.appendChild(newPagination);

    window.initPagination?.();
    const newActiveFilters = doc.querySelector('.facet-active-filters');
    const activeFiltersContainer = document.querySelector('.facet-active-filters');

    if (activeFiltersContainer) {
      activeFiltersContainer.innerHTML = newActiveFilters
        ? newActiveFilters.innerHTML
        : '';

      const minInput = facetForm.querySelector('.price-min');
      const maxInput = facetForm.querySelector('.price-max');
      const minVal = minInput?.value;
      const maxVal = maxInput?.value;

      if (minVal || maxVal) {
        const span = document.createElement('span');
        span.className = 'facet-active-filter';

        let label = '';
        if (minVal && maxVal) {
          label = `$${minVal} – $${maxVal}`;
        } else if (minVal) {
          label = `From $${minVal}`;
        } else if (maxVal) {
          label = `Up to $${maxVal}`;
        }

        span.innerHTML = `
          <a href="#" class="facet-remove" data-price-type="both">
            <span>${label}</span>
            <svg xmlns="https://www.w3.org/2000/svg" class="icon icon-close" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </a>
        `;

        activeFiltersContainer.appendChild(span);
      }
    }

    window.history.pushState({}, '', url);

  } catch (error) {
    console.error('AJAX filtering error:', error);
  } finally {
    productContainer.classList.remove('is-loading');
    updateClearAllVisibility();
  }
}

  /* ------------------------------
     CHECKBOX CHANGE EVENT
  --------------------------------*/
  facetForm.addEventListener('change', function () {
    const query = serializeForm(facetForm);
    const currentUrl = new URL(window.location.href);
    const searchQuery = currentUrl.searchParams.get('q');

    let url = window.location.pathname + '?';

    if (searchQuery) {
      url += `q=${searchQuery}&`;
    }

    url += query;

    updateProducts(url);
  });

  /* ------------------------------
     PRICE INPUT DEBOUNCE
  --------------------------------*/
  const minInput = facetForm.querySelector('.price-min');
  const maxInput = facetForm.querySelector('.price-max');

  if (minInput && maxInput) {

    let debounceTimer;

    [minInput, maxInput].forEach(input => {
      input.addEventListener('input', () => {

        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
          const query = serializeForm(facetForm);
          const currentUrl = new URL(window.location.href);
          const searchQuery = currentUrl.searchParams.get('q');

          let url = window.location.pathname + '?';

          if (searchQuery) {
            url += `q=${searchQuery}&`;
          }

          url += query;

          updateProducts(url);
        }, 500);

      });
    });
  }

  /* ------------------------------
     REMOVE FILTER CLICK + CLEAR ALL
  --------------------------------*/
  document.addEventListener('click', function (e) {
    const clearBtn = e.target.closest('[data-clear]');
    if (clearBtn) {
      e.preventDefault();
      facetForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.checked = false;
      });

      const minInput = facetForm.querySelector('.price-min');
      const maxInput = facetForm.querySelector('.price-max');
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';

      const currentUrl = new URL(window.location.href);
      const searchQuery = currentUrl.searchParams.get('q');

      let cleanUrl = window.location.pathname;

      if (searchQuery) {
        cleanUrl += `?q=${searchQuery}`;
      }

      updateClearAllVisibility();
      updateProducts(cleanUrl);
      return;
    }

    const removeEl = e.target.closest('.facet-remove');
    if (!removeEl) return;

    e.preventDefault();

    const priceType = removeEl.dataset.priceType;
    if (priceType) {

      if (priceType === 'both') {
        const minInput = facetForm.querySelector('.price-min');
        const maxInput = facetForm.querySelector('.price-max');

        if (minInput) minInput.value = '';
        if (maxInput) maxInput.value = '';

        updateClearAllVisibility();
      }

      const query = serializeForm(facetForm);
      const currentUrl = new URL(window.location.href);
      const searchQuery = currentUrl.searchParams.get('q');

      let url = window.location.pathname + '?';

      if (searchQuery) {
        url += `q=${searchQuery}&`;
      }

      url += query;

      updateProducts(url);
      return;
    }

    const href = removeEl.closest('a')?.getAttribute('href');
    if (!href) return;

    const urlParams = new URLSearchParams(href.split('?')[1]);

    facetForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
      input.checked = urlParams.getAll(input.name).includes(input.value);
    });

    updateProducts(href);

  });

  updateClearAllVisibility();

});

/* ------------------------------
   COLOR SWATCH FILTER
--------------------------------*/
document.addEventListener('change', function (e) {
  if (!e.target.matches('.facet-color-item input')) return;

  const label = e.target.closest('.facet-color-item');

  if (e.target.checked) {
    label.classList.add('active');
  } else {
    label.classList.remove('active');
  }
});

// FILTER SORT JS
document.addEventListener('change', function (e) {
  if (!e.target.matches('.SortBy')) return;

  const sortSelect = e.target;
  const productGrid = document.querySelector('.ProductGridContainer');
  if (!productGrid) return;

  const sortValue = sortSelect.value;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortValue);

  productGrid.classList.add('is-loading');

  fetch(url.toString())
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('.ProductGridContainer');

      if (newGrid) {
        productGrid.innerHTML = newGrid.innerHTML;
        window.history.replaceState({}, '', url.toString());
      }

      productGrid.classList.remove('is-loading');
    })
    .catch((error) => {
      console.error('Sorting error:', error);
      productGrid.classList.remove('is-loading');
    });
});

/* ------------------------------
   FACET ACCORDION
--------------------------------*/
function initFacetAccordion() {

  const wrapper = document.querySelector(".collection-with-sidebar");
  const accordionItems = document.querySelectorAll(".facet-group");

  if (!wrapper) return;

  const layout = wrapper.classList;

  accordionItems.forEach((item, index) => {
    const content = item.querySelector(".facet-content");

    item.removeAttribute("open");
    content.style.height = "0px";
    content.style.opacity = "0";

    if (layout.contains("all_open")) {
      item.setAttribute("open", true);
    }

    if (layout.contains("first_open") && index === 0) {
      item.setAttribute("open", true);
    }

    if (item.hasAttribute("open")) {
      content.style.height = content.scrollHeight + "px";
      content.style.opacity = "1";

      setTimeout(() => {
        content.style.height = "auto";
      }, 300);
    }
  });

  accordionItems.forEach(item => {
    const summary = item.querySelector("summary");
    const content = item.querySelector(".facet-content");

    summary.removeEventListener("click", handleClick);
    summary.addEventListener("click", handleClick);

    function handleClick(e) {
      e.preventDefault();

      if (item.hasAttribute("open")) {

        content.style.height = content.scrollHeight + "px";

        requestAnimationFrame(() => {
          content.style.height = "0px";
          content.style.opacity = "0";
        });

        setTimeout(() => {
          item.removeAttribute("open");
        }, 350);

      } else {

        item.setAttribute("open", true);

        content.style.height = "0px";
        content.style.opacity = "0";

        requestAnimationFrame(() => {
          content.style.height = content.scrollHeight + "px";
          content.style.opacity = "1";
        });

        setTimeout(() => {
          content.style.height = "auto";
        }, 350);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", initFacetAccordion);
document.addEventListener("shopify:section:load", initFacetAccordion);
document.addEventListener("shopify:section:select", initFacetAccordion);

/* ------------------------------
   MOBILE FILTER DRAWER
--------------------------------*/
document.addEventListener("DOMContentLoaded", function () {

  const toggleBtn = document.querySelector(".mobile-filter-toggle");
  const drawer = document.querySelector(".MobileFacetDrawer");
  const overlay = document.querySelector(".mobile-filter-overlay");
  const closeBtn = document.querySelector(".mobile-filter-close");
  const applyBtn = document.querySelector(".mobile-filter-apply");
  const facetForm = document.querySelector(".FacetFiltersForm");

  if (!toggleBtn || !drawer) return;

  function openDrawer() {
    drawer.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("drawer-open");
  }

  toggleBtn.addEventListener("click", openDrawer);
  closeBtn.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);

  applyBtn.addEventListener("click", function () {
    closeDrawer();
  });

  facetForm?.addEventListener("change", function () {
    if (window.innerWidth <= 767) {
      setTimeout(() => {
        closeDrawer();
      }, 400);
    }
  });

});

/* ------------------------------
   FACET OPEN STATE (MOBILE/DESKTOP)
--------------------------------*/
document.addEventListener("DOMContentLoaded", function () {

  function controlFacetOpenState() {

    const isMobile = window.innerWidth <= 767;
    const facetGroups = document.querySelectorAll(".facet-group");

    facetGroups.forEach(group => {

      if (isMobile) {
        group.removeAttribute("open");
      } else {
        if (group.querySelector("input:checked")) {
          group.setAttribute("open", true);
        }
      }

    });
  }

  controlFacetOpenState();
  window.addEventListener("resize", controlFacetOpenState);

});

